<template>
    <div class="center-diagram-fintoc">
        <p class="has-text-weight-semibold" style="font-size:1.5em">
            Para generar tu reporte necesitamos que conectes el Sii de tu empresa.
        </p>
        <p class="" style="font-size:1em">
            CFORemoto nunca compartirá tu información con terceros.
        </p>
        <p class="" style="font-size:1em">
            Revísalo en nuestros 
                <a
                    :href="
                        `http://${publicPath}/pdf/Politicas_Privacidad_CFO_App.pdf`
                    "
                    download
                    class="basic-terms-and-conditions"
                    target="_blank"
                >
                Términos y condiciones.
                </a>
            </p>
            <p>
                <img class="fintoc-diagram" :src="fintoc_diagram" />
        </p>
    </div>
</template>
<script>
import fintoc_diagram from "@/assets/images/diagrama_fintoc.svg";

export default {
    name: "Diagram",
    data() {
        return {
            publicPath: window.location.hostname,
            fintoc_diagram: fintoc_diagram,
        };
    },
}
</script>
<style scoped>
.basic-terms-and-conditions {
    text-decoration: underline;
}
.center-diagram-fintoc {
    text-align: center;
}
.fintoc-diagram {
    margin-top: -4.5%;
    margin-left: 13%;
    width: 80%;
}
@media screen and (min-width: 769px) and (max-width: 930px) {
    .fintoc-diagram {
        margin-top: -2%;
        margin-left: 12%;
        width: 90%;
    }
}
@media screen and (min-width: 551px) and (max-width: 768px) {
    .fintoc-diagram {
        margin-top: -1%;
        margin-left: 7%;
        width: 100%;
    }
}
@media screen and (min-width: 1px) and (max-width: 550px) {
    .fintoc-diagram {
        margin-top: 0%;
        margin-left: 6%;
        width: 100%;
    }
}
</style>